<template lang="pug">
    el-dialog(:title="!ruleForm.id ? '新建请假': '修改'",width="95%" :visible.sync='visible' :modal-append-to-body='false' :append-to-body='true' @close="closeForm()")
        el-form(:model="ruleForm", :inline="false" :rules="rules", ref="ruleForm", label-width="150px",label-position='right' @submit.native.prevent)
            el-card(shadow="never")
                div(slot="header")
                    font(style="font-weight: bold;font-size:18px;") 选择会员
                div(class="search-box")
                    el-row(:span='24')
                        el-col(:md='12' :sm="12")
                            el-form-item(label="姓名/级别/手机号码:" prop="memberName" )
                                el-input.inputWidth(v-model="memberName" placeholder="请输入姓名/级别/手机号码")
                        el-col(:md='12' :sm="12" style='text-align:right;')
                            el-button(@click="getLeftDataSrc" type='primary' icon='el-icon-search') 查询
                    el-table(:data="ruleForm.leftData" @row-click="showRow" border)
                            el-table-column(header-align='center', align='center', width='60')
                                template(scope="scope")
                                    el-radio(class="radio" v-model="radio" :label="scope.$index")
                            el-table-column(prop="mobile" label="会员账号" align='center')
                            el-table-column(prop="name" label="会员姓名" align='center')
                            el-table-column(prop="idCard" label="身份证" align='center')
                            el-table-column(prop="level" label="会员级别" align='center')
                            el-table-column(prop="gender" label="会员性别" align='center')
                                template(slot-scope="scope")
                                    font(v-if="scope.row.gender === 0") 男
                                    font(v-if="scope.row.gender === 1") 女
                    el-pagination(@size-change='sizeChangeHandle', @current-change='currentChangeHandle', :current-page='pageIndex', :page-sizes='[10, 20, 50, 100]', :page-size='pageSize', :total='totalPage', layout='total, sizes, prev, pager, next, jumper')
            br
            el-card(shadow="never")
                div(slot="header")
                    font(style="font-weight: bold;font-size:18px;") 选择培训
                div
                    el-row
                        el-col(:md='6' :sm="12")
                            el-form-item(label="培训ID" )
                                el-input.inputWidth(v-model='dataForm.trainCode' clearable )
                        el-col(:md='6' :sm="12")
                            el-form-item(label="培训名称" )
                                el-input.inputWidth(v-model='dataForm.name' clearable )
                        el-col(:md='6' :sm="12")
                            el-form-item(label="培训时间")
                                el-date-picker.inputWidth( style='width:210px;'  v-model='dataForm.pxTime' range-separator="至" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期" value-format="timestamp")
                        el-col(:md='6' :sm="12" style='text-align:right;')
                            el-button(@click="getTrainTableDataSrc" type='primary' icon='el-icon-search') 查询
                        el-table(:data="ruleForm.trainTableData" @row-click="showRow2" border  height="300" v-loading="dataListLoading")
                            el-table-column(header-align='center', align='center', width='60')
                                template(scope="scope")
                                    el-radio(class="radio" v-model="radio2" :label="scope.$index")
                            el-table-column(prop="trainCode" label="培训ID" align='center')
                            el-table-column(prop="name" label="培训名称" align='center')
                            el-table-column(prop="orgName" label="主办方" align='center')
                            el-table-column(prop="type" label="培训类别" align='center')
                                template(slot-scope="scope")
                                    font(v-if="scope.row.type === '1'") 单次培训
                                    font(v-if="scope.row.type === '2'") 整期培训
                                    font(v-if="scope.row.type === '3'") 青少年儿童培训
                                    font(v-if="scope.row.type === '4'") 个人定制化
                                    font(v-if="scope.row.type === '5'") 团体定制化
                            el-table-column(prop="level" label="培训级别" align='center')
                            el-table-column(prop="trainStrDate" label="培训开始时间" align='center')
                            el-table-column(prop="placesName" label="培训场地" align='center')
                        //- el-pagination(@size-change='sizeChangeHandle2', @current-change='currentChangeHandle', :current-page='pageIndex2', :page-sizes='[10, 20, 50, 100]', :page-size='pageSize2', :total='totalPage2', layout='total, sizes, prev, pager, next, jumper')
            br
            //- 迭6
            el-card(shadow="never")
                div(slot="header")
                    font(style="font-weight: bold;font-size:18px;") 选择请假人（代报名）
                div
                    el-table(:data="ruleForm.agencyData" height="300" @selection-change="agencyDataChange" border v-loading="agencyloading")
                            el-table-column(type='selection', header-align='center', align='center', width='60')
                            el-table-column(prop="name" label="姓名" align='center')
            br
            el-card(shadow="never")
                div(slot="header")
                    font(style="font-weight: bold;font-size:18px;") 选择课程
                div
                    el-row
                        el-col(:span='24' style='margin-bottom:15px;')
                            div(style="float:right")
                                el-button(@click="getCourseTableDataSrc" type='primary' icon='el-icon-search') 查询
                        el-row(v-if="showVoucherUpload" :span='24' style='margin-bottom:10px;')
                            el-col(:span='24')
                                el-form-item(label="上传凭证:" prop="certificateUrl" label-width="150px")
                                    el-input.inputWidth(v-model="ruleForm.certificateUrl" v-show='false')
                                    el-upload(:http-request="uploadCertificateFile" action="useless" :headers="headers" :before-upload="beforeAvatarUpload" :show-file-list="false" class="avatar-uploader")
                                        img(v-if="certificateUrl" :src="certificateUrl" class="avatar")
                                        i(v-else class="el-icon-plus avatar-uploader-icon")
                        el-table(:data="ruleForm.courseTableData" height="300" highlight-current-row @current-change="courseDataChange" border v-loading="lessonLoading")
                            el-table-column(header-align='center', align='center', width='60')
                                template(scope="scope")
                                    el-radio(class="radio" v-model="radio3" :label="scope.$index")
                            el-table-column(prop="code" label="课程编号" align='center')
                            el-table-column(prop="trainTime" label="培训日期" align='center')
                            el-table-column(prop="strTime" label="开始时间" align='center')
                            el-table-column(prop="endTime" label="结束时间" align='center')
                            el-table-column(prop="placeCode" label="场地编号" align='center')
        span.dialog-footer(slot="footer")
            el-button(type="primary" @click="ruleFormSubmit()" :disabled="clickFlag") 确 定
            el-button(@click="closeForm()") 取 消
</template>
<script>
import util from '@/libs/util.js'
import { Trianset } from '@/api/pages/train/vacate';
    export default {
        data () {
            return {
                pageSize: 10,
                pageIndex: 1,
                totalPage: 0,
                pageSize2: 10,
                pageIndex2: 1,
                totalPage2: 0,
                memberName: '',
                courseDataChangeList: [],
                radio: '',
                radio2: '',
                radio3: '',
                multipleSelection: [],
                selected: {},
                selected2: {},
                clickFlag: false,
                headers: {
                    token: util.cookies.get('token'),
                    authorization: 'Bearer ' + util.cookies.get('authorization'),
                    'Content-Type': 'application/json; charset=utf-8'
                },
                certificateUrl: '',
                showVoucherUpload: false,
                dataForm: {
                    trainCode: '',
                    name: '',
                    pxTime: ''
                },
                dataListLoading: false, //选择培训的loading
                lessonLoading: false, //选择课程的loading
                delTableList: [],
                sysOrgList: [],
                provinceList: [],
                cityDisbaled: true,
                provinceDisabled: true,
                nameFont: 20,
                venueIdDisabled: true,
                venueList: [],
                placesInfoList: [],
                ageMaxMenMin: 0,
                ageMaxWomenMin: 0,
                ageMaxMenMax: 100,
                ageMaxWomenMax: 100,
                menDisabled: false,
                womenDisabled: false,
                ruleForm: {
                    id: null,
                    leftData: [],
                    trainTableData: [],
                    courseTableData: [],
                    certificateUrl: '',
                    matchType: '1',
                    matchId: '',
                    matchName: '',
                    userGroupId: '',
                    cityCode: '',
                    cityName: '',
                    provinceCode: '',
                    provinceName: '',
                    venueId: '',
                    ctType: '',
                    applySize: '',
                    projectType: null,
                    level: '',
                    bench: 1,
                    applyDate: [],
                    matchSignStartTime: null,
                    matchSignEndTime: null,
                    matchStartTime: null,
                    imgList: '',
                    gameDescription: '',
                    matchDescription: '',
                    imgDetailList: '',
                    repeatSign: 0,
                    genderLimit: 2,
                    ageLimit: '',
                    ageMinMen: undefined,
                    ageMaxMen: undefined,
                    ageMinWomen: undefined,
                    ageMaxWomen: undefined,
                    scoreMin: 0,
                    venueAddress: '',
                    // 迭6
                    agencyData: [] //选择请假人（代报名）
                },
                flagType: '',
                loading: null,
                levelDisabled: true,
                levelOptions: [],
                rules: {
                    matchName: [
                        { message: '比赛名称不能为空!', trigger: 'blur' },
                        { max: 20, message: '长度不能超过20个字符!' }
                    ],
                    certificateUrl: [
                        { required: true, message: '请上传凭证!', trigger: 'change' }
                    ]
                },
                visible: false,
                listImageUrl: '',
                detailImageUrl: '',
                // 迭6
                agencyDataChangeList: [],
                agencyloading: false
            }
        },
        // created() {
        //     this.$refs['d2-quill'].quill.blur();

        // },
        mounted () {
            //this.restaurants = this.loadAll()
            // this.initCity()
        },
        methods: {
            init (id, flagType) {
                this.ruleForm.trainTableData = []
                this.ruleForm.leftData = []
                this.ruleForm.courseTableData = []
                //默认加载会员列表
                this.getLeftData()
                this.clickFlag = false
                this.visible = true
                this.ruleForm.id = id || null
                this.courseDataChangeList = []
                this.radio3 = ''
                this.ruleForm.certificateUrl = ''
                this.certificateUrl = ''
                this.showVoucherUpload = false
                // this.getTrainTableData()
            },
            courseDataChange (val) {
                if (!val) {
                    this.courseDataChangeList = []
                    this.radio3 = ''
                    this.showVoucherUpload = false
                    return
                }
                this.radio3 = this.ruleForm.courseTableData.indexOf(val)
                this.courseDataChangeList = [val]
                this.checkVoucherRequired(val)
            },
            // 校验所选课程距离当前时间是否小于等于24小时，决定是否需要上传凭证
            checkVoucherRequired (course) {
                if (!course || !course.trainTime || !course.strTime) {
                    this.showVoucherUpload = false
                    this.ruleForm.certificateUrl = ''
                    this.certificateUrl = ''
                    return
                }
                const startTime = new Date(course.trainTime + ' ' + (course.strTime || '00:00') + ':00').getTime()
                const now = Date.now()
                const diff = startTime - now
                this.showVoucherUpload = diff > 0 && diff <= 24 * 60 * 60 * 1000
                if (!this.showVoucherUpload) {
                    this.ruleForm.certificateUrl = ''
                    this.certificateUrl = ''
                }
            },
            // 上传凭证前的格式/大小校验
            beforeAvatarUpload (file) {
                const isImage = file.type === 'image/jpg' || file.type === 'image/png' || file.type === 'image/jpeg'
                const isLt2M = file.size / 1024 / 1024 < 2
                if (!isImage) this.$message.error('上传图片只能是 jpg,jpeg,png 格式!')
                if (!isLt2M) this.$message.error('上传图片大小不能超过 2MB!')
                return isImage && isLt2M
            },
            // 自定义上传
            uploadCertificateFile (param) {
                const fd = new FormData()
                fd.append('type', 'pxLeave')
                fd.append('file', param.file)
                this.$http({
                    url: this.$http.adornUrl('/upload/uploadFile'),
                    method: 'post',
                    data: fd
                }).then(data => {
                    if (data && data.code === 0) {
                        // 把接口返回的 id 作为 certificateUrl 提交给后台；url 用于图片预览
                        this.ruleForm.certificateUrl = data.bean.id
                        this.certificateUrl = data.bean.url || URL.createObjectURL(param.file)
                        this.$message.success('上传成功!')
                        if (this.$refs.ruleForm) this.$refs.ruleForm.clearValidate()
                    } else {
                        this.$message.error(data.msg || '上传失败!')
                    }
                }).catch(() => {
                    this.$message.error('上传失败!')
                })
            },
            getLeftDataSrc () {
                this.pageIndex = 1
                this.getLeftData()
            },
            //刷新会员查询table
            getLeftData () {
                this.$http({
                    url: this.$http.adornUrl(`/mbMember/getMemberList`),
                    method: 'post',
                    params: this.$http.adornParams({
                        'page': this.pageIndex,
                        'rows': this.pageSize,
                        'name': this.memberName,
                        'status': 1//只查询已实名认证的会员
                    })
                }).then(data => {
                    if (data && data.code === 0) {
                        this.ruleForm.leftData = data.list.rows
                        this.totalPage = data.list.total
                    } else {
                        this.ruleForm.leftData = []
                        this.totalPage = 0
                    }
                    // 培训清空
                    this.ruleForm.trainTableData = []
                    // 请假人(代报名)清空
                    this.ruleForm.agencyData = []
                    this.agencyDataChangeList = []
                    // 课程清空
                    this.ruleForm.courseTableData = []
                    this.courseDataChangeList = []
                })
            },
            //选中某一条会员信息，查询该会员参加的培训
            showRow (row) {
                //赋值给radio
                this.radio = this.ruleForm.leftData.indexOf(row);
                this.selected = row;
                console.log(this.radio, 'radio')
                console.log(row)
                this.pageIndex2 = 1;
                this.getTrainTableData(row.id)
                this.radio2 = ''
                this.radio3 = ''
                this.ruleForm.courseTableData = []
                this.courseDataChangeList = []
                this.ruleForm.agencyData = []
                this.agencyDataChangeList = []
            },
            getTrainTableDataSrc () {
                this.pageIndex2 = 1
                this.getTrainTableData(this.selected.id)
            },
            //刷新培训查询table
            getTrainTableData (mbId) {
                this.dataListLoading = true;
                let applyStrTime = '';
                let applyEndTime = '';
                if (this.dataForm.pxTime) {
                    if (this.dataForm.pxTime.length > 0) {
                        applyStrTime = this.dataForm.pxTime[0];
                        applyEndTime = this.dataForm.pxTime[1];
                    }
                }
                this.$http({
                    url: this.$http.adornUrl('/pxTrain/list'),
                    method: 'post',
                    data: {
                        trainCode: this.dataForm.trainCode,
                        name: this.dataForm.name,
                        applyStrTime: applyStrTime,
                        applyEndTime: applyEndTime,
                        page: 1,
                        limit: 9999,
                        mbId: mbId
                    }
                }).then(data => {
                    console.log(data);
                    if (data && data.code === 0) {
                        let list = data.page.records
                        if (list.length>0) {
                          list = list.filter(e => (e.state == 3 || e.state == 4 || e.state == 5 || e.state == 6) && e.type != '1')
                        }
                        this.ruleForm.trainTableData = list;
                        this.totalPage2 = data.page.total;
                    } else {
                        this.ruleForm.trainTableData = [];
                        this.totalPage2 = 0;
                    }
                    this.dataListLoading = false;
                    // 请假人(代报名)清空
                    this.ruleForm.agencyData = []
                    this.agencyDataChangeList = []
                    // 课程清空
                    this.ruleForm.courseTableData = []
                    this.courseDataChangeList = []
                });
            },
            //选中某一条培训信息，根据会员ID和培训ID查询课程信息
            showRow2 (row) {
                //赋值给radio
                this.radio2 = this.ruleForm.trainTableData.indexOf(row);
                this.selected2 = row;
                console.log(this.radio2, 'radio2')
                console.log(row)
                this.pageIndex3 = 1;
                this.courseDataChangeList = []
                this.getCourseTableData(this.selected.id, this.selected2.id)
                // 代请假人数据请求
                this.agencyDataChangeList = []
                let params = {
                    mbId: this.selected.id,
                    trainId: this.selected2.id
                }
                this.getAgencyData(params)
            },
            getCourseTableDataSrc () {
                this.pageIndex3 = 1
                this.getCourseTableData(this.selected.id, this.selected2.id)
            },
            //刷新课程查询table
            getCourseTableData (mbId, trainId) {
                this.lessonLoading = true;
                this.$http({
                    url: this.$http.adornUrl('/pxTrainCourse/listLeave'),
                    method: 'post',
                    data: {
                        mbId: mbId,
                        trainId: trainId
                    }
                }).then(data => {
                    console.log(data);
                    if (data && data.length > 0) {
                        this.ruleForm.courseTableData = data;
                    } else {
                        this.ruleForm.courseTableData = [];
                    }
                    this.lessonLoading = false;
                });
            },
            openFullScreen () {
                this.loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                })
            },
            //新增方法
            ruleFormSubmit () {
                this.openFullScreen()
                this.clickFlag = true
                if (!this.courseDataChangeList || this.courseDataChangeList.length === 0) {
                    this.loading.close()
                    this.clickFlag = false
                    this.$message.warning('请选择需要请假的课程！')
                    return
                }
                if (this.showVoucherUpload && !this.ruleForm.certificateUrl) {
                    this.loading.close()
                    this.clickFlag = false
                    this.$message.warning('请上传凭证！')
                    return
                }
                let trainCourseId = []
                this.courseDataChangeList.forEach(e => {
                    trainCourseId.push(e.id)
                });
                let obj = {};
                obj.memberId = this.selected.id//会员ID
                obj.trainId = this.selected2.id//培训ID
                obj.trainCourseId = trainCourseId.join()//课程ID
                obj.isIssue = 1//补课卷是否发放(1=未发放，2=已发放)
                obj.certificateUrl = this.showVoucherUpload ? this.ruleForm.certificateUrl : ''
                // 增加请假人(代报名)字段
                obj.insteadFlag = !!this.agencyDataChangeList.length
                obj.insteads = this.agencyDataChangeList
                this.$http({
                    url: this.$http.adornUrl(`/pxLeave/save`),
                    method: 'post',
                    data: obj
                }).then((data) => {
                    this.loading.close()
                    if (data && data.code === 0) {
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration: 1500,
                            onClose: () => {
                                this.visible = false
                                this.$emit('refreshDataList')
                            }
                        })
                    } else {
                        this.clickFlag = false
                        this.$message.error(data.msg)
                    }
                }).catch(() => {
                    this.loading.close()
                    this.clickFlag = false
                    this.$message.error('请求错误')
                })
            },
            closeForm () {
                this.radio3 = ''
                this.ruleForm.certificateUrl = ''
                this.certificateUrl = ''
                this.showVoucherUpload = false
                this.courseDataChangeList = []
                this.visible = false
            },
            // 每页数
            sizeChangeHandle (val) {
                this.pageSize = val
                this.pageIndex = 1
                this.getLeftData();
            },
            // // 每页数2
            // sizeChangeHandle2 (val) {
            //     this.pageSize2 = val
            //     this.pageIndex2 = 1
            //     this.getTrainTableData(this.selected2.id)
            // },
            // 当前页
            currentChangeHandle (val) {
                this.pageIndex = val
                this.getLeftData();
            },
            // 当前页2
            // currentChangeHandle (val) {
            //     this.pageIndex2 = val
            //     this.getTrainTableData(this.selected2.id)
            // },
            checkAll (val) {
                this.nowSelectData = val;
            },
            // 迭6
            agencyDataChange (val) {
                this.agencyDataChangeList = val.map(item => {
                    return item.id
                })
            },
            getAgencyData (params) {
                this.agencyloading = true
                Trianset(params).then(res => {
                    if (res.code === 0) {
                        this.ruleForm.agencyData = res.insteadList
                        this.agencyloading = false
                    }
                })
            }
        }
    }
</script>
<style>
    .inputWidth{
        width: 210px;
    }
    .font_later{
        padding-left:20px;
        font-weight: bold;
        color: #909399;
    }
    .font_color{
        font-weight: bold;
        color: #909399;
    }
    .font_style{
        font-weight: bold;
        color: red;
    }
    .dialog-footer{
        padding-bottom:150px;
    }

    /* 提示框 */
    .el-tooltip__popper.is-light{
        border: 1px solid #C0C4CC;
    }

    .el-tooltip__popper[x-placement^=bottom] .popper__arrow{
        border-bottom-color: grey  !important ;
    }

    .toolTip>p{
        margin: 0;
        padding-top: 10px;
        height:14px;
        line-height:14px;
        font-size:14px;
        color: #606266;
    }

    /* 弹出遮罩层 兼容ie*/
    .el-dialog__wrapper {
        width: 100% !important;
        height: 100% !important;
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        overflow: auto;
        margin: 0;
    }

    .search-box .el-radio__label {
        display: none;
        padding-left: 0px !important;
    }

    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
        width: 80px;
        height: 80px;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }

    .avatar {
        width: 80px;
        height: 80px;
        display: block;
    }

</style>
